import {
    GET_ALL_EXPLORE_DESIGNS,
    SET_ALL_EXPLORE_DESIGNS,
    SET_EXPLORE_DESIGNS_LOADING
} from '../../@types/thunk.types'
import { fetchExploreDesigns } from '../../../services/v3/DesignLab/DesignLab'
import { ExploreDesignAction } from './ExploreDesignSlice'

export const ExploreDesignThunks = {
    [GET_ALL_EXPLORE_DESIGNS]:
        (params, isExploreMore = false, requetBody) =>
        async (dispatch) => {
            try {
                dispatch(ExploreDesignAction[SET_EXPLORE_DESIGNS_LOADING](true))
                const data = await fetchExploreDesigns(params, requetBody)
                dispatch(
                    ExploreDesignAction[SET_ALL_EXPLORE_DESIGNS]({
                        data,
                        merge: data.currentPage > 0 || isExploreMore === true
                    })
                )
                dispatch(
                    ExploreDesignAction[SET_EXPLORE_DESIGNS_LOADING](false)
                )
            } catch (e) {
                dispatch(
                    ExploreDesignAction[SET_EXPLORE_DESIGNS_LOADING](false)
                )
            }
        }
}
